import { convertArrayToCSV } from 'convert-array-to-csv';
import { find, get, orderBy } from 'lodash';
import moment from 'moment';
import GET_MERGED_PRACTICE_AREAS from '../../shared/queries/getMergedPracticeAreasQuery';
import GET_ORG_UNITS_AGGREGATE_REPORT from '../queries/getOrgUnitAggregateReportQuery';

const fetchData = async orgUnitId => {
  if (!orgUnitId) throw new Error('No Org Unit ID selected.');

  const apollo = require('../../../apollo/configureApollo').default();

  const result = await apollo.query({
    query: GET_ORG_UNITS_AGGREGATE_REPORT,
    variables: {
      id: orgUnitId
    },
    fetchPolicy: 'cache-first'
  });

  if (result.error) throw new Error(result.error);
  return result.data;
};

const prepareData = async queryData => {
  const orgUnitData = orderBy(
    get(queryData, 'aggregateOrgUnitReport.AppraisalOrgUnits', []),
    ou => [ou.Appraisal.ConductAppraisalEndDate, ou.Appraisal.Id],
    ['desc', 'asc']
  );

  const preparedData = [];

  const apollo = require('../../../apollo/configureApollo').default();
  const practiceAreas = get(
    await apollo.query({
      query: GET_MERGED_PRACTICE_AREAS
    }),
    'data.practiceAreasMerged',
    []
  );

  if (!practiceAreas.length) throw new Error('Error retrieving practice area data');

  for (const { MergedPracticeAreaIds, Name, Acronym } of practiceAreas) {
    const dataPoint = {
      'Practice Area Name': `${Name} (${Acronym})`
    };

    orgUnitData.map(ou => {
      const appraisalProgramYear = ou.AppraisalProgramYear;
      const calendarYear = moment(ou.Appraisal.ConductAppraisalEndDate).year();
      const ouTargetPracticeAreas = get(ou, 'AppraisalOrgUnitTargetPracticeAreas', []);
      const targetPracticeArea = find(ouTargetPracticeAreas, tpa =>
        MergedPracticeAreaIds.includes(tpa.PracticeArea.Id)
      );

      const pgl = get(targetPracticeArea, 'PracticeGroup.Level', 'N/A');

      dataPoint[`Year ${appraisalProgramYear} (${calendarYear}) Practice Group Level`] = pgl;

      if (queryData.isPercentageVisible) {
        const percent = get(targetPracticeArea, 'AggregatePercentage', null);

        dataPoint[`Year ${appraisalProgramYear} (${calendarYear}) Percent`] =
          percent !== null ? percent : 'N/A';
      }
    });

    preparedData.push(dataPoint);
  }

  return preparedData;
};

export const getCsvData = async orgUnitId => {
  const queryData = await fetchData(orgUnitId);
  const data = await prepareData(queryData);
  return convertArrayToCSV(data);
};
